import { NavigationError } from '@angular/router';

const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i;
const RELOAD_MARK_KEY = 'stale-chunk-reload';
const RELOAD_LOOP_WINDOW_MS = 10_000;

/** True when a lazy route failed because its chunk no longer exists on the server. */
export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return STALE_CHUNK_PATTERN.test(message);
}

/**
 * A tab kept open across a deploy asks for a lazy chunk of the build it started with. Deploys keep
 * old chunks for a few days, so this only hits a very old tab: load the target URL fresh, on the
 * new build, instead of leaving the navigation dead. The user was navigating away anyway, so no
 * in-progress form is lost. A session mark stops a reload loop when the cause is something else.
 */
export function reloadOnStaleChunk(navigationError: NavigationError): void {
  if (!isStaleChunkError(navigationError.error)) return;
  const mark = `${navigationError.url}|`;
  const previous = readMark();
  if (previous.startsWith(mark) && Date.now() - Number(previous.slice(mark.length)) < RELOAD_LOOP_WINDOW_MS) return;
  writeMark(`${mark}${Date.now()}`);
  window.location.assign(navigationError.url);
}

function readMark(): string {
  try {
    return sessionStorage.getItem(RELOAD_MARK_KEY) ?? '';
  } catch {
    return '';
  }
}

function writeMark(value: string): void {
  try {
    sessionStorage.setItem(RELOAD_MARK_KEY, value);
  } catch {
    // Storage blocked: reload anyway — the loop guard is best effort.
  }
}
